import PropTypes from 'prop-types'
import BasicObject from 'model/basicObject'
import { isNil } from 'ramda'

class ActiveRecord extends BasicObject {
  constructor(init) {
    super(init)
    // console.log('> ActiveRecord constructor -', init)
    if (isNil(init)) return undefined
    this._created_at = init.created_at
    this._updated_at = init.updated_at
  }

  static shape = {
    ...BasicObject.shape,
    created_at: PropTypes.ISO8601DateTime,
    updated_at: PropTypes.ISO8601DateTime
  }

  get created_at() {
    return this._created_at
  }

  get updated_at() {
    return this._updated_at
  }
}

export default ActiveRecord
